<template>
  <div
    :class="classes"
    data-cy="ds-container"
  >
    <slot />
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import type { DSContainerProps } from "@/src/design_system/layouts_and_containers/container/types";
import {
  DS_CONTAINER_CLASSES,
  DS_CONTAINER_SIZE_CLASS,
  DS_CONTAINER_SURFACE_CLASS,
} from "@/src/design_system/layouts_and_containers/container/constants/classes";
import { DS_SIZE } from "@/src/design_system/shared/types/size";
import { DS_SURFACE } from "@/src/design_system/shared/types/surface";

const props = withDefaults(defineProps<DSContainerProps>(), {
  size: DS_SIZE.Medium,
  surface: DS_SURFACE.Default,
});

const classes = computed(() => [
  DS_CONTAINER_CLASSES.Root,
  DS_CONTAINER_SIZE_CLASS[props.size],
  DS_CONTAINER_SURFACE_CLASS[props.surface],
]);
</script>
